import { Alert, styled } from '@yuno/design-system-web'
import { useTranslation } from 'react-i18next'

type ConnectionSetupInstructionsDescriptionProps = {
  providerName: string
}

const Container = styled('div')`
  margin-top: 20px;
  margin-bottom: 20px;
`

const AlertText = styled(Alert)`
  max-height: 66px;
  font-size: 12px;
  padding-bottom: 16px;
  padding-top: 16px;
`

export const ConnectionSetupInstructionsDescription = ({
  providerName,
}: ConnectionSetupInstructionsDescriptionProps) => {
  const { t } = useTranslation()
  return (
    <Container>
      <AlertText
        children={<p>{`${t('setupInstructionsOne')}${providerName}${t('setupInstructionsTwo')}`}</p>}
        severity="info"
      />
    </Container>
  )
}
